import React from 'react';
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { useLanguage } from "@/contexts/LanguageContext";
import ZohoContactForm from "@/components/ZohoContactForm";

const SAC: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="SAC Quimical: atendimento e suporte ao cliente"
        description="Fale com o SAC da Quimical por telefone, e-mail ou formulário. Atendimento para dúvidas, suporte e informações."
        canonical="https://quimical.com.br/sac"
      />
      <Header />
      
      <main className="pt-24">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-16">
          <div className="container mx-auto px-4">
            <div className="text-center max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
                Serviço de Atendimento ao Cliente
              </h1>
              <p className="text-lg text-muted-foreground">
                Estamos aqui para ajudar você. Entre em contato conosco através dos canais disponíveis ou envie sua mensagem através do formulário abaixo.
              </p>
            </div>
          </div>
        </section>

        {/* Contact Info Cards */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              <Card className="text-center border-2 hover:border-primary/20 transition-colors">
                <CardHeader>
                  <div className="mx-auto w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                    <Phone className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl">Telefone</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground mb-4">
                    Ligue gratuitamente para nosso SAC
                  </p>
                  <a 
                    href="tel:08005917215" 
                    className="text-primary font-semibold hover:underline text-lg"
                  >
                    0800 591 7215
                  </a>
                </CardContent>
              </Card>

              <Card className="text-center border-2 hover:border-primary/20 transition-colors">
                <CardHeader>
                  <div className="mx-auto w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                    <Mail className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl">E-mail</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground mb-4">
                    Envie sua dúvida por e-mail
                  </p>
                  <a 
                    href="mailto:cal@quimical.com.br" 
                    className="text-primary font-semibold hover:underline text-lg"
                  >
                    cal@quimical.com.br
                  </a>
                </CardContent>
              </Card>

              <Card className="text-center border-2 hover:border-primary/20 transition-colors">
                <CardHeader>
                  <div className="mx-auto w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                    <MapPin className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl">Endereço</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground mb-4">
                    Nossa sede em Minas Gerais
                  </p>
                  <address className="text-primary font-semibold not-italic">
                    Rua Belo Horizonte, 6<br />
                    Santo Antônio - Arcos/MG<br />
                    35599-170
                  </address>
                </CardContent>
              </Card>
            </div>

            {/* Business Hours */}
            <Card className="mb-16 max-w-2xl mx-auto">
              <CardHeader className="text-center">
                <div className="mx-auto w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                  <Clock className="w-6 h-6 text-primary" />
                </div>
                <CardTitle className="text-xl">Horário de Atendimento</CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                <div className="space-y-2">
                  <p className="font-semibold">Segunda a Quinta-feira</p>
                  <p className="text-muted-foreground">07:00 às 17:00</p>
                  <p className="font-semibold mt-4">Sexta-feira</p>
                  <p className="text-muted-foreground">07:00 às 16:00</p>
                </div>
              </CardContent>
            </Card>

            {/* Zoho SAC form */}
            <div className="max-w-4xl mx-auto flex justify-center">
              <ZohoContactForm />
            </div>

            {/* WhatsApp CTA */}
            <div className="text-center mt-16">
              <Card className="max-w-md mx-auto bg-green-50 border-green-200">
                <CardContent className="pt-6">
                  <h3 className="text-lg font-semibold mb-4">Prefere falar no WhatsApp?</h3>
                  <Button 
                    className="bg-green-600 hover:bg-green-700 text-white"
                    onClick={() => window.open('https://wa.me/5537998606150', '_blank')}
                    aria-label="Abrir conversa no WhatsApp"
                  >
                    Falar no WhatsApp
                  </Button>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default SAC;
